import React from 'react';
import PropTypes from 'prop-types';
import { TextField} from '@mui/material';
import { useTranslation } from 'react-i18next';

const UserNameInputType1  = ({width,isEditProfile,form,setForm,placeholder,label,name,helperText}) =>{
    const {t} = useTranslation("translate");
    const [validInput,setValidInput] = React.useState(true);
    const [invalidCharacter,setInvalidCharacter] = React.useState('');
    const [msgInput,setMsgInput] = React.useState('');
    let typingTimer;



    const defineMsg = () =>{
        if(invalidCharacter != '' && !validInput){
            if(invalidCharacter== " "){
                setMsgInput(t("profile.modal_edit.not_accept_spaces"))
            }else{
                setMsgInput(t("profile.modal_edit.character_error")+' '+invalidCharacter)
            }
        }else{
            if(String(form.username).length >= 30){
                setMsgInput(t("profile.modal_edit.username_max_length"))
            }else{
                setMsgInput(t("profile.modal_edit.enter_username"))
            }
        }
    }

    const validateUsername = (username) =>{
        let re = /^[a-zA-Z0-9.]+$/;
        return re.test(username);
    }

    const handleOnChange = (e)=>{
        clearTimeout(typingTimer)
        const {name,value} = e.target;

        if(value != ''){
            if(String(value).length <= 30){
                if(validateUsername(value) ){
                    setValidInput(true)
                    setForm({...form, [name]: (value+'').replace(/ /g, ""),validateAttr:{...form.validateAttr,username:true}})
                }else{
                    setInvalidCharacter((value+'').charAt(value.length -1));
                    setValidInput(false)
                }

            }
            defineMsg()
        }else{
            setForm({...form,[name]:'',validateAttr:{...form.validateAttr,username:false}});
            setValidInput(true)
        }

    }



    const handleFinishWrite = ()=>{
        clearTimeout(typingTimer)
        defineMsg();
    }

    const handleInitWrite = ()=>{
        clearTimeout(typingTimer)
    }

    const handleFocus = ()=>{
        clearTimeout(typingTimer)
        defineMsg();
    }




    return (
        <React.Fragment>
            <TextField
                sx={{
                    width:width,
                    marginTop:'20px',
                    color:'#fff',
                    "& ,input":{
                        color:'#fff',
                        '.Mui-disabled':{
                            color: '#fff'
                        }
                    },
                    "& label.Mui-focused":{
                        color:'#fff',
                        '.Mui-disabled':{
                            color: '#fff'
                        }
                    },
                    "& label":{
                        color:'#fff',
                        '.Mui-disabled':{
                            color: '#fff'
                        }
                    },
                    '& .MuiInput-underline:after': {
                        borderBottomColor: 'green',
                        '.Mui-disabled':{
                            color: '#fff'
                        }
                    },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                        borderColor: '#fff',
                        },
                        '&:hover fieldset': {
                        borderColor: '#43B02A',
                        },
                        '&.Mui-focused fieldset': {
                        borderColor: '#43B02A',
                        },
                        '.Mui-disabled':{
                            color: '#fff'
                        }
                    },
                    "@media (max-width:768px)": {
                        width:'100%'
                    },
                    fontFamily:'BentonSansBBVA-Medium,sans-serif',
                    '.Mui-disabled':{
                        color: '#fff'
                    }
                }}
                type="text"
                error = {!validInput}
                id="standard-error-helper-text"
                label={label}
                helperText={msgInput != '' ? msgInput : helperText}
                variant="standard"
                autoComplete='off'
                required
                name={name}
                disabled={isEditProfile}
                value={form.username}
                placeholder={placeholder ? placeholder : ''}
                onChange={(e)=>{handleOnChange(e)}}
                onKeyDown={handleInitWrite}
                onKeyUp={handleFinishWrite}
                onFocus={handleFocus}
                onMouseOver={handleFocus}
            />
        </React.Fragment>
    )
};

UserNameInputType1.defaultProps = {
    placeholder: 'Username',
    name: 'username',
    label: 'Username',
    helperText:"Enter value",
    width: '45%'
}


UserNameInputType1 .propTypes = {
    setMsg: PropTypes.func,
    setError: PropTypes.func,
    isEditProfile: PropTypes.bool,
    form: PropTypes.object,
    setForm: PropTypes.func,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    helperText: PropTypes.string,
    width: PropTypes.any
};

export default UserNameInputType1 ;
